import React from 'react';
import { Transition } from '@headlessui/react';

const AnimateFadeIn = ( { isVisible, children } ) => {
	return (
		<Transition appear={true} show={isVisible}
			className="tw-transition tw-duration-300 tw-ease-in"
			enter="tw-transition-opacity tw-duration-300"
			enterFrom="tw-opacity-0"
			enterTo="tw-opacity-100"
			leave="tw-transition-opacity tw-duration-0"
			leaveFrom="tw-opacity-100"
			leaveTo="tw-opacity-0"
		>
			{children}
		</Transition>
	);
};

export default AnimateFadeIn;
